import React, { useContext, useState, useCallback } from "react";
import { LanguageContext } from "../LanguageContext"; // Import the LanguageContext

const FAQS = ({ faqs }) => {
  const { language } = useContext(LanguageContext); // Get the current language
  const [activeIndex, setActiveIndex] = useState(null);



  const toggleFAQ = useCallback((index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  }, []);

  return (
    <section className="snapseed">
      <div className="faq-container">
        <h2 className="faq-title">
          {language === "english"
            ? "Frequently Asked Questions"
            : "अक्सर पूछे जाने वाले सवाल"}
        </h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              key={index}
            >
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <h3>{faq.question[language]}</h3>
                <span>{activeIndex === index ? "-" : "+"}</span>
              </div>
              <div
                className="faq-answer"
                style={{
                  maxHeight: activeIndex === index ? "500px" : "0",
                  overflow: "hidden",
                  transition: "max-height 0.3s ease-in-out",
                }}
              >
                <p>{faq.answer[language]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(FAQS);